import React from 'react';
import '../applications-css/Application.css'
import '../applications-css/ThemeSelector.css'
import {changeToLightTheme,
        changeToDarkTheme,
        changeToGreenTheme,
        changeToPurpleTheme} from "../desktop-components/ThemeChanger"

function ThemeSelector(props) {
  return(
    <div className="outsideWrapper">
      <button className="fillWidth" onClick={() => changeToLightTheme()}> Light Theme </button>
      <button className="fillWidth" onClick={() => changeToDarkTheme()}> Dark Theme </button>
      <button className="fillWidth" onClick={() => changeToGreenTheme()}> Green Theme </button>
      <button className="fillWidth" onClick={() => changeToPurpleTheme()}> Purple Theme </button>
    </div>
  )
}

export default ThemeSelector;
